//import { hasPermission } from '@/auth/utils'

export default [
  // *===============================================---*
  // *--------- USER ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/users/list',
    name: 'users.list',
    component: () => import('@/views/modules/user/users-list/UsersList.vue'),
    meta: {
      module: 'users',
      pageTitle: 'Users',
      breadcrumb: [
        { text: 'Users', active: true, },
       
      
      ],

    }
  },
  // {
  //   path: '/users/view/:id',
  //   name: 'users.update',
  //   component: () => import('@/views/modules/user/users-view/UsersView.vue'),
  //   meta: {
  //     module: 'users'
  //   }
  // },
  {
    path: '/users/:id/edit',
    name: 'users.update',
    component: () => import('@/views/modules/user/users-edit/UsersEdit.vue'),
    meta: {
      module: 'users',
      pageTitle: 'Users',
      breadcrumb: [
        { text: 'Edit user', active: true, },
      ]
       
    }
  },



  // *===============================================---*
  // *--------- plans ---- ---------------------------------------*
  // *===============================================---*

  // {
  //   path: '/plans/garden/create',
  //   name: 'plans.garden.create',
  //   component: () => import('@/views/modules/plans/garden-plan/create-plan/CreatePlan.vue'),
  //   meta: {
  //     module: 'plans.garden'
  //   }
  // },






  // *===============================================---*
  // *--------- Drivers ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/drivers/list',
    name: 'drivers.list',
    component: () => import('@/views/modules/driver/driver-list/DriversList.vue'),
    meta: {
      module: 'drivers',
      pageTitle: 'Drivers',
      breadcrumb: [
        { text: 'Drivers', active: true, },
      ]
    
    
    }
  },
  { 
    path: '/drivers/edit/:id',
    name: 'drivers.edit',
    component: () => import('@/views/modules/driver/driver-edit/DriverEdit.vue'),
    meta: {
      module: 'drivers',
      pageTitle: 'Drivers',
      breadcrumb: [
        { text: 'Drivers', to: { name: 'drivers.list'} },
        { text: 'Edit Driver', active: true, },
      ]
    
    }
  },
  { 
    path: '/drivers/create',
    name: 'drivers.create',
    component: () => import('@/views/modules/driver/driver-create/DriverCreate.vue'),
    meta: {
      module: 'drivers',
      pageTitle: 'Drivers',
      breadcrumb: [
        { text: 'Drivers', to: { name: 'drivers.list'} },
        { text: 'Add Driver', active: true, },
      ]
    
    }
  },




  // *===============================================---*
  // *--------- roles ---- ---------------------------------------*
  // *===============================================---*

  {
    path: '/roles/list',
    name: 'roles.list',
    component: () => import('@/views/modules/roles/roles-list/RolesList.vue'),
    meta: {
      module: 'roles',
      pageTitle: 'List Roles',
      breadcrumb: [
        { text: 'Roles', active: true, },
        { text: 'List Roles', active: true, },
        { text: 'Create Role' }
      ],
    }
  },




  // *===============================================---*
  // *--------- permissions ---- ---------------------------------------*
  // *===============================================---*

  {
    path: '/permissions',
    name: 'permissions',
    component: () => import('@/views/modules/permissions/Permission'),
    meta: {
      module: 'permissions',
      pageTitle: 'Give Permissions To Role',
      breadcrumb: [
        { text: 'Roles', active: true, },
        { text: 'List Roles', to: { name: 'roles'} },
      ],
    }
  },




  // *===============================================---*
  // *--------- Geofence ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/geofence/list',
    name: 'geofence.list',
    component: () => import('@/views/modules/geofence/geofence-list/GeofenceList.vue'),
    meta: {
      module: 'geofence',
      pageTitle: 'List Geofence',
      breadcrumb: [
        { text: 'Geofences', active: true, },
        { text: 'List Geofence', active: true, },
        { text: 'Create Geofence', to: { name: 'geofence.create'} }
      ],
    }
  },

  {
    path: '/geofence/create',
    name: 'geofence.create',
    component: () => import('@/views/modules/geofence/geofence-create/GeofenceCreate.vue'),
    meta: {
      module: 'geofence',
      pageTitle: 'Create Geofence',
      breadcrumb: [
        { text: 'Geofences', to: { name: 'geofence.list'} },
        { text: 'Create Geofence', active: true, },
      ],
    }
  },

  {
    path: '/geofence/edit/:id',
    name: 'geofence.edit',
    component: () => import('@/views/modules/geofence/geofence-edit/GeofenceEdit'),
    meta: {
      module: 'geofence',
      pageTitle: 'Edit Geofence',
      breadcrumb: [
        { text: 'Geofences', to: { name: 'geofence.list'} },
        { text: 'Edit Geofence', active: true, },
      ],
    }
  },




  // *===============================================---*
  // *--------- types ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/types/list',
    name: 'types.list',
    component: () => import('@/views/modules/type/types-list/TypesList.vue'),
    meta: {
      module: 'types',
      pageTitle: 'Types',
      breadcrumb: [
        
        { text: 'Types', active: true, },
      ]
    }
  },


  {
    path: '/types/edit/:id',
    name: 'types.update',
    component: () => import('@/views/modules/type/types-edit/TypeEdit'),
    meta: {
      module: 'types',
      pageTitle: 'Types',
      breadcrumb: [
        { text: 'Types', to: { name: 'types.list'} },
        { text: 'Edit Type', active: true, },
      ]
    }
  },


  // *===============================================---*
  // *--------- groups ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/groups/list',
    name: 'groups.list',
    component: () => import('@/views/modules/group/groups-list/GroupsList.vue'),
    meta: {
      module: 'groups',
      pageTitle: 'Groups',
      breadcrumb: [
       
        { text: 'Groups', active: true, },
      ]
    }
  },

  {
    path: '/groups/edit/:id',
    name: 'groups.edit',
    component: () => import('@/views/modules/group/groups-edit/GroupEdit'),
    meta: {
      module: 'groups',
      pageTitle: 'Groups',
      breadcrumb: [
        { text: 'Groups', to: { name: 'groups.list'} },
        { text: 'Group Edit', active: true, },
      ]
    }
  },



  // *===============================================---*
  // *--------- contracts ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/contracts/list',
    name: 'contracts.list',
    component: () => import('@/views/modules/contract/contracts-list/ContractsList.vue'),
    meta: {
      module: 'contracts',
      pageTitle: 'List Contracts',
      breadcrumb: [
        { text: 'List Contracts', active: true, },
        { text: 'Create Contract', to: { name: 'contracts.create'} }
      ],
    }
  },

  {
    path: '/contracts/edit/:id',
    name: 'contracts.edit',
    component: () => import('@/views/modules/contract/contracts-edit/ContractEdit'),
    meta: {
      module: 'contracts',
      pageTitle: 'Edit Contract',
      breadcrumb: [
        { text: 'List Contracts', to: { name: 'contracts.list'} },
        { text: 'Edit Contract', active: true, },
      ],
    }
  },


  // *===============================================---*
  // *--------- work shift -------------------------------------------*
  // *===============================================---*
  {
    path: '/workShifts/list',
    name: 'workShifts.list',
    component: () => import('@/views/modules/work-shift/list/List.vue'),
    meta: {
      module: 'workShifts',
      pageTitle: 'Work Shifts List',
      breadcrumb: [
        { text: 'Work Shifts List', active: true }
      ],
    }
  },

  {
    path: '/workShifts/edit/:id',
    name: 'workShifts.edit',
    component: () => import('@/views/modules/work-shift/edit/Edit'),
    meta: {
      module: 'workShifts',
      pageTitle: 'Edit Work Shift',
      breadcrumb: [
        { text: 'Work Shifts List', to: { name: 'workShifts.list'} },
        { text: 'Edit Work Shift', active: true, },
      ],
    }
  },

  // *===============================================---*
  // *--------- Maintenances -------------------------------------------*
  // *===============================================---*

  {
    path: '/maintenances/list',
    name: 'maintenances.list',
    component: () => import('@/views/modules/maintenance/list/list.vue'),
    meta: {
      module: 'maintenances',
      pageTitle: 'MAINTENANCES_LIST_TITLE',
      breadcrumb: [
        { text: 'MAINTENANCES_LIST_TITLE', active: true, }
      ],
    }
  },
  {
    path: '/maintenances/create',
    name: 'maintenances.create',
    component: () => import('@/views/modules/maintenance/create/create.vue'),
    meta: {
      module: 'maintenances',
      pageTitle: 'MAINTENANCES_CREATE_TITLE',
      breadcrumb: [
        { text: 'MAINTENANCES_LIST_TITLE', to: { name: 'maintenances.list'} },
        { text: 'MAINTENANCES_CREATE_TITLE', active: true, },
      ],
    },
  },
  {
    path: '/maintenances/:id/edit',
    name: 'maintenances.edit',
    component: () => import('@/views/modules/maintenance/edit/edit.vue'),
    meta: {
      module: 'maintenances',
      pageTitle: 'MAINTENANCES_EDIT_TITLE',
      breadcrumb: [
        {
          text: 'MAINTENANCES_LIST_TITLE',
          to: { name: 'maintenances.list'}
        },
        {
          text: 'MAINTENANCES_EDIT_TITLE',
          active: true,
        },
      ],
    },
  },
  {
    path: '/maintenances/device/:id',
    name: 'maintenances.device.list',
    component: () => import('@/views/modules/maintenance/QRcode/list.vue'),
    meta: {
      module: 'maintenances',
      pageTitle: 'MAINTENANCES_DEVICE_LIST_TITLE',
      breadcrumb: [
        {
          text: 'MAINTENANCES_LIST_TITLE',
          active:true
        }
      ]
    },
  },
  {
    path: '/maintenances/:id/details',
    name: 'maintenances.show',
    component: () => import('@/views/modules/maintenance/details/details.vue'),
    meta: {
      module: 'maintenances',
      pageTitle: 'MAINTENANCES_DETAILS_TITLE',
      breadcrumb: [
        {
          text: 'MAINTENANCES_LIST_TITLE',
          to: { name: 'maintenances.list'}
        },
        {
          text: 'MAINTENANCES_DETAILS_TITLE',
          active:true
        }
      ]
    }
  },

  // *===============================================---*
  // *--------- calendars ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/calendars/list',
    name: 'calendars_index',
    component: () => import('@/views/modules/calendar/calendars-list/CalendarsList.vue'),
    meta: {
      module: 'calendars'
    }
  },

  {
    path: '/calendars/edit/:id',
    name: 'calendars_update',
    component: () => import('@/views/modules/calendar/calendar-edit/CalendarEdit'),
    meta: {
      module: 'calendars'
    }
  },

  {
    path: '/calendars/create',
    name: 'calendars_create',
    component: () => import('@/views/modules/calendar/calendar/Calendar.vue'),
    meta: {
      module: 'calendars'
    }
  },



  // *===============================================---*
  // *--------- devices ---- ---------------------------------------*
  // *===============================================---*
  //
  // {
  //   path: '/devices',
  //   name: 'devices_index',
  //   component: () => import('@/views/pages/device/ListDevices'),
  //   meta: {
  //     pageTitle: 'List Devices',
  //     breadcrumb: [
  //       {
  //         text: 'Devices',
  //         to: { name: 'devices_index'}
  //       },
  //       {
  //         text: 'List Devices',
  //         active: true,
  //       },
  //     ],
  //   },
  // },

  {
    path: '/containers/list',
    name: 'containers.list',
    component: () => import('@/views/modules/containers/ListContainers.vue'),
    meta: {
      module: 'containers',
      pageTitle: 'List All Containers',
      breadcrumb: [
        { text: 'Containers', active: true, },
        { text: 'List Containers', active: true },
        // { text: 'Create Container', to: { name: 'containers.create'}},
      ],
    }
  },


  {
    path: '/containers/create',
    name: 'containers.create',
    component: () => import('@/views/modules/containers/CreateContainer.vue'),
    meta: {
      module: 'containers',
      pageTitle: 'Create Container',
      breadcrumb: [
        { text: 'Containers', active: true, },
        { text: 'Create Container', active: true },
        { text: 'List All Containers', to: { name: 'containers.list'}},
      ],
    }
  },

  {
    path: '/containers/:id/edit',
    name: 'containers.edit',
    component: () => import('@/views/modules/containers/EditContainer.vue'),
    meta: {
      module: 'containers',
      pageTitle: 'Edit Container',
      breadcrumb: [
        { text: 'Containers', active: true, },
        { text: 'Edit Container', active: true },
        { text: 'List All Containers', to: { name: 'containers.list'}},
        { text: 'Create New Container', to: { name: 'containers.create'}},
      ],
    }
  },


  {
    path: '/rfids/list',
    name: 'rfids.list',
    component: () => import('@/views/modules/rfid/ListRfid.vue'),
    meta: {
      module: 'rfids',
      pageTitle: 'List All Rfid',
      breadcrumb: [
        { text: 'Rfid', active: true, },
        { text: 'List Rfid', active: true },
        { text: 'Create Rfid', to: { name: 'rfids.create'}},
      ],
    }
  },

  {
    path: '/rfids/create',
    name: 'rfids.create',
    component: () => import('@/views/modules/rfid/CreateRfid.vue'),
    meta: {
      module: 'rfids',
      pageTitle: 'Create Rfid',
      breadcrumb: [
        { text: 'Rfid', active: true, },
        { text: 'Create Rfid', active: true, },
        { text: 'List Rfid', to: { name: 'rfids.list'} }
      ],
    }
  },

  {
    path: '/rfids/:id/edit',
    name: 'rfids.edit',
    component: () => import('@/views/modules/rfid/EditRfid.vue'),
    meta: {
      module: 'rfids',
      pageTitle: 'Edit Rfid',
      breadcrumb: [
        { text: 'Rfid', active: true, },
        { text: 'Edit Rfid', active: true, },
        { text: 'List Rfid', to: { name: 'rfids.list'} }
      ],
    }
  },


  {
    path: '/devices/list',
    name: 'devices.list',
    component: () => import('@/views/modules/device/devices-list/DevicesList.vue'),
    meta: {
      module: 'devices',
      pageTitle: 'List Devices',
      breadcrumb: [
        { text: 'Devices', active: true, },
        { text: 'List Devices', active: true, },
        { text: 'Create Devices', to: { name: 'devices.create'} }
      ],
    }
  },
  {
    path: '/devices/create',
    name: 'devices.create',
    component: () => import('@/views/modules/device/devices-create/CreateDevice'),
    meta: {
      module: 'devices',
      pageTitle: 'Create Device',
      breadcrumb: [
        { text: 'Devices', to: { name: 'devices.list'} },
        { text: 'Create Device', active: true, },
      ],
    },
  },

  {
    path: '/devices/:id/edit',
    name: 'devices.edit',
    component: () => import('@/views/modules/device/devices-edit/EditDevice'),
    meta: {
      module: 'devices',
      pageTitle: 'Edit Device',
      breadcrumb: [
        {
          text: 'Devices',
          to: { name: 'devices.list'}
        },
        {
          text: 'Edit Device',
          active: true,
        },
      ],
    },
  },

  {
    path: '/account-setting',
    name: 'account.settings',
    component: () => import('@/views/modules/account-setting/AccountSetting.vue'),
    meta: {
      pageTitle: 'Account Settings',
      breadcrumb: [
        {
          text: 'Pages',
        },
        {
          text: 'Account Settings',
          active: true,
        },
      ],
    },
  },

  //
  {
    path: '/log',
    name: 'activity-log',
    component: () => import('@/views/modules/activity-log/ActivityLog'),
    meta: {
      pageTitle: 'Activity Log',
      breadcrumb: [
        {
          text: 'Activity Log',
          active: true,
        },
      ],
    },
  },



  // devices
  // {
  //   path: '/devices/create',
  //   name: 'devices_create',
  //   component: () => import('@/views/modules/device/device-create/DeviceCreate.vue'),
  //     meta: {
  //       pageTitle: 'Create Device',
  //       breadcrumb: [
  //         {
  //           text: 'Devices',
  //           to: { name: 'devices_index'}
  //         },
  //         {
  //           text: 'Create Device',
  //           active: true,
  //         },
  //       ],
  //     },
  // },
  // {
  //   path: '/devices/edit/:id',
  //   name: 'devices_edit',
  //   component: () => import('@/views/modules/device/device-edit/DeviceEdit.vue'),
  // },

  // {
  //   path: '/profile/account-setting',
  //   name: 'pages-account-setting',
  //   component: () => import('@/views/modules/account-setting/AccountSetting.vue'),
  //   meta: {
  //     pageTitle: 'Account Settings',
  //     breadcrumb: [
  //       {
  //         text: 'Pages',
  //       },
  //       {
  //         text: 'Account Settings',
  //         active: true,
  //       },
  //     ],
  //   },
  // },


  // Notifications Module

  {
    path: '/alerts/list',
    name: 'alerts.list',
    component: () => import('@/views/modules/alerts/alerts-list/AlertsList.vue'),
    meta: {
      module: 'alerts',
      pageTitle: 'Alerts',
      breadcrumb: [
        
        { text: 'List of alerts', active: true, },
      
      ],
    }
  },
  {
    path: '/alerts/create',
    name: 'alerts.create',
    component: () => import('@/views/modules/alerts/alerts-create/CreateAlert'),
    meta: {
      module: 'alerts',
      pageTitle: 'Create Alert',
      breadcrumb: [
        { text: 'List of alerts', to: { name: 'alerts.list'} },
         { text: 'Create Alert', active: true, },
       
      ],
    },
  },

  {
    path: '/alerts/:id/edit',
    name: 'alerts.edit',
    component: () => import('@/views/modules/alerts/alerts-edit/EditAlert'),
    meta: {
      module: 'alerts',
      pageTitle: 'Edit Alerts',
      breadcrumb: [
         { text: 'List of alerts', to: { name: 'alerts.list'} },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
